module.exports = __webpack_public_path__ + "img/floor2_2.c0fd12b9.jpg";